import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { SharedService } from 'app/modules/common/services/shared-service';
import { DoctorBillingService } from 'app/modules/fuse/services/doctor-billing.service';

@Component({
    selector: 'app-transfer-actuaciones-modal',
    templateUrl: './transfer-actuaciones-modal.component.html',
    styleUrls: ['./transfer-actuaciones-modal.component.scss'],
    standalone: false
})
export class TransferActuacionesModalComponent implements OnInit {

  transferActuacionesFormGroup:  UntypedFormGroup;

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<TransferActuacionesModalComponent>,  
  public doctorBillingService: DoctorBillingService,
  public fb: UntypedFormBuilder,
  private sharedService: SharedService) { }

  ngOnInit(): void {
    this.transferActuacionesFormGroup = this.fb.group({
      Date: [{value: ''}, Validators.required],  
    });
  }

  transferActuaciones(){
    if (this.transferActuacionesFormGroup.invalid) {
      this.showInvalidFormControls(this.transferActuacionesFormGroup);
      return;
    }
    let model = this.transferActuacionesFormGroup.value;
    const date = (model.Date !== null) ? DateHelper.getUTCDateString(DateHelper.getNativeDate(model.Date)) : null;
    this.doctorBillingService.TransferActuaciones(date)
        .subscribe(res => {
          if (res.result == 1 && res.code === 0) {
            this.sharedService.ShowSnackBar('Traspaso realizado correctamente', 'Okay', 2000);
            this.dialogRef.close();
          }else{
            this.sharedService.ShowSnackBar('error');
          }
        }, err => {
          this.sharedService.ShowSnackBar('error');
          console.error(err);
        });
  }

  cancel(){
    this.dialogRef.close();
  }
  
  showInvalidFormControls(formGroup: UntypedFormGroup) {
    if (formGroup !== undefined) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            control.markAsDirty({ onlySelf: true });
            control.markAsTouched({ onlySelf: true });
        });
    }
  }
}
